export default __webpack_public_path__ + "static/media/24ccdce211e893e7e9d7b2c6fd5bc6ec.1b1b622d.png";